const LOCK_NAME = "pj:token-refresh"

/**
 * Serialises refresh-token exchanges across tabs.
 *
 * The backend rotates the refresh token on every use and revokes the whole session when a spent
 * one comes back — so two tabs exchanging the same token at once would sign the user out
 * everywhere. `baseApi`'s in-memory mutex only ever covered the tab it lives in.
 *
 * `refresh` has to read the stored token itself: a tab that waited here must use the value the
 * winner wrote, not the one it was holding before it started waiting.
 */
export const withRefreshLock = async <T>(
  refresh: () => T | Promise<T>,
): Promise<T> => {
  // No Web Locks while server-rendering, where there are no other tabs to race anyway.
  if (typeof navigator === "undefined" || !("locks" in navigator)) {
    return refresh()
  }

  return navigator.locks.request(LOCK_NAME, refresh)
}
